"use strict";

jQuery(document).ready(function ($) {
  function isOverflown(element) {
    return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
  }
  var els = document.getElementsByClassName('data-grid__table--wrapper');
  function checkOverflown() {
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (isOverflown(el)) {
        el.classList.add('overflown');
      } else {
        el.classList.remove('overflown');
      }
    }
  }
  if (els) {
    window.onresize = checkOverflown;
    checkOverflown();
  }
});